import React, { useState } from "react";
import { ImPlus } from "react-icons/im";
import NavTitle from "./NavTitle";

const Category = ({ onCategorySelect }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showCategory, setShowCategory] = useState(true);

  const items = [
    { _id: 990, title: "All", value: "All"  },
    { _id: 991, title: "Necklace", value: "Necklace" },
    { _id: 992, title: "Earring", value: "Earring" },
    { _id: 993, title: "Ring", value: "Ring" },
    { _id: 994, title: "Bangle", value: "Bangle" },
    { _id: 995, title: "Chain", value: "Chain" },
    { _id: 996, title: "Dollar", value: "Dollar" },
    { _id: 997, title: "Stud", value:"Stud" },
    { _id: 998, title: "BombayNeckles", value: "BombayNeckles" },
    { _id: 999, title: "Machine chain", value: "Machine chain" },
    { _id: 1000, title: "Braslet", value: "Braslet" },
    { _id: 1001, title: "FancyDollar", value: "FancyDollar" },
    { _id: 1002, title: "JimikiDropsEaringStuds", value: "JimikiDropsEaringStuds" },
    { _id: 1003, title: "FancyStuds", value: "FancyStuds" },
  ];

  const handleCategoryClick = (value) => {
    setSelectedCategory(value);
    onCategorySelect(value); // Send the selected category to the parent
  };

  return (
    <div className="w-full">
       <div
        onClick={() => setShowCategory(!showCategory)}
        className="cursor-pointer"
      >
        <NavTitle title="Shop by Category" icons={true} />
      </div>
     {showCategory && (
      <ul className="flex flex-col gap-4 text-sm lg:text-base text-[#767676]">
      {items.map(({ _id, title, value, icons }) => (
        <li
          key={_id}
          className={`border-b-[1px] border-b-[#F0F0F0] pb-2 flex items-center justify-between ${
            selectedCategory === value ? "text-primeColor font-bold" : ""
          }`}
          onClick={() => handleCategoryClick(value)}
        >
          {title}
          {icons && (
            <ImPlus className="text-[10px] lg:text-xs text-gray-400" />
          )}
        </li>
      ))}
    </ul>
     )}
      
    </div>
  );
};

export default Category;
